import { render, staticRenderFns } from "./vertBar.vue?vue&type=template&id=4f10dad4&scoped=true&"
import script from "./vertBar.vue?vue&type=script&lang=js&"
export * from "./vertBar.vue?vue&type=script&lang=js&"
import style0 from "./vertBar.vue?vue&type=style&index=0&id=4f10dad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f10dad4",
  null
  
)

export default component.exports